export function getDaysRange(startDate: Date, endDate: Date) {
  if (!(startDate && endDate)) return [];

  let dateReached = false;
  // NOTE: The Date object is passed by reference, so don't mutate it directly but instead clone it in a new variable
  const clonedStartingDate = new Date(startDate?.getTime());
  const clonedEndingDate = new Date(endDate?.getTime());
  const currentDate: Date = new Date(clonedStartingDate?.getTime());
  const dayRange: Date[] = [clonedStartingDate];

  if (clonedEndingDate.getDate() - clonedStartingDate.getDate() === 0) {
    return dayRange;
  }

  while (!dateReached) {
    currentDate.setDate(currentDate?.getDate() + 1);
    dateReached = currentDate.getDate() - clonedEndingDate.getDate() === 0;
    const clonedCurrentDate = new Date(currentDate?.getTime());
    dayRange.push(clonedCurrentDate);
  }

  return dayRange;
}

export function removeDaysRange(dateRange: Date[], flagDate: Date) {
  if (!(flagDate && dateRange)) return dateRange;
  let updatedDaysRange: Date[] = [];
  updatedDaysRange = dateRange.filter((date: Date) => date.getDate() >= flagDate.getDate());

  return updatedDaysRange;
}

export function dateBetweenTwoDates(check: Date, from: Date, to: Date) {
  return check.getTime() <= to.getTime() && check.getTime() >= from.getTime();
}
